/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingCommitmentBatchResponse {
    getFixupPrototypeFunction() { return BillingCommitmentBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<BillingCommitmentBatchResponse>): BillingCommitmentBatchResponse {
        let obj = Object.assign(new BillingCommitmentBatchResponse(), model);
        BillingCommitmentBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingCommitmentBatchResponse>): BillingCommitmentBatchResponse {
        if (!model) return null;
        return BillingCommitmentBatchResponse.newInstance(<BillingCommitmentBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingCommitmentBatchResponse) {
        if (!obj) return;

        models.BillingCommitmentBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingCommitmentBatchResponse): boolean {
        Object.setPrototypeOf(obj, BillingCommitmentBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.BillingCommitmentDetail.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.BillingCommitmentDetail; };

}
